import { Injectable } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { Subject } from 'rxjs';
import { ValidationErrorsService } from '@avano/avano-components/avano-validation/validation-errors-service';
import { ErrorDetail } from '@avano/avano-components/avano-validation/errors-details/errors-details.component';
import { TranslateService } from '@ngx-translate/core';
import { translationKeys } from '../../core';

type BuiltInValidationErrorTypes = { min: number; actual: number } & { max: number; actual: number } & { requiredLength: number; actualLength: number }; // min // max // minlength and maxlength

@Injectable({ providedIn: 'root' })
export class ScipValidationErrorsService implements ValidationErrorsService {
  changed$: Subject<ErrorDetail[]> = new Subject<ErrorDetail[]>();
  currentErrors: Map<string, ErrorDetail> = new Map();

  private validationsI18n = translationKeys.avano.errorsDetails.common.validations;

  private errorDescriptions: Map<string, (errorInput: BuiltInValidationErrorTypes) => string> = new Map([
    ['min', (errorReason) => this.translateService.instant(this.validationsI18n.minValue, { value: errorReason.min }) as string],
    ['max', (errorReason) => this.translateService.instant(this.validationsI18n.maxValue, { value: errorReason.max }) as string],
    ['required', () => this.translateService.instant(this.validationsI18n.required) as string],
    // // ['requiredTrue', 'x'],
    // // ['email', 'x'],
    ['minlength', (errorReason) => this.translateService.instant(this.validationsI18n.minLength, { value: errorReason.requiredLength }) as string],
    ['maxlength', (errorReason) => this.translateService.instant(this.validationsI18n.maxLength, { value: errorReason.requiredLength }) as string]
    // ['pattern', 'x'],
    // ['nullValidator', 'x'],
    // ['compose', 'x'],
    // ['composeAsync', 'x'],
    // Built-In Validators: https://angular.io/api/forms/Validators
  ]);

  constructor(private translateService: TranslateService) {}

  addValidationError(key: string, errorDetail: ErrorDetail): void {
    this.currentErrors.set(key, errorDetail);
    this.changed$.next(Array.from(this.currentErrors.values()));
  }

  clearValidationError(key: string): void {
    this.currentErrors.delete(key);
    this.changed$.next(Array.from(this.currentErrors.values()));
  }

  getErrorDescriptionText(allErrors: ValidationErrors): string {
    const firstUsableErrorDescription = Object.entries(allErrors)
      .map(([key, value]) => this.errorDescriptions.get(key)?.(value))
      .find((description) => description !== undefined);
    return firstUsableErrorDescription ?? (this.translateService.instant(this.validationsI18n.unknownFallback) as string);
  }
}
